<template lang="pug">
  div(class="vkb_nak" class="vkb_nak_fsoel vkb_nak_ruerup_rente")
    div(ref="heading" class="large-12")
      hr.topspace

      div.row(v-if="showForm1" ref="form1")
        div.small-12.medium-12.large-4.columns

          div(class="row form-spacing")
            div(class="large-12 medium-12 small-12 columns")
              h4(class="feedback")
                span(:class="[ 'feedback-before', validForm1 ? 'validated' : '' ]")
                span Meine Daten

        div.small-12.medium-12.large-8.columns
          div(class="row form-spacing")
            div(class="large-12 medium-12 small-12 columns")
              div(class="float-left margin-top-label")
                label(class="padding-top padding-left-25")
                  b Persönliche Angaben

          div.row.form-spacing
            div(class="large-6 medium-6 small-12 columns")
              label(class="margin-top-label")
                i(class="fo fo-exclamation info-tooltip")
                  span.hint(v-html="text.tooltip_material")
                span(class="padding-top") {{ text.label_material }}

            div(class="large-6 medium-6 small-12 columns")
              div(class="radio-button-wrapper form-spacing mt-2")
                input(v-model="frmMarital.marital_status" value="1" class="custom-radio" type="radio")
                label(@click="onChangeMarital(1)")
                  span
                  div {{ optionsMarital[0].label }}

              div(class="radio-button-wrapper form-spacing")
                input(v-model="frmMarital.marital_status" value="2" class="custom-radio" type="radio")
                label(@click="onChangeMarital(2)")
                  span
                  div {{ optionsMarital[1].label }}

          div.row.form-spacing
            div(class="large-6 medium-6 small-12 columns")
              label(class="margin-top-label ml-5")
                span(class="padding-top") Geburtsjahr*

            div(class="large-6 medium-6 small-12 columns")
              n-number(
                v-model="frmMarital.birth_year"
                format="number"
                placeholder="z.B. 1975"
                :valid="!$v.frmMarital.birth_year.$invalid"
                :checkValid="checkValid"
                :error="errorMessages.birth_year.valid"
                @input="onInputBirthYear"
              )

          div.row.form-spacing
            div(class="large-6 medium-6 small-12 columns")
              label(class="margin-top-label")
                i(class="fo fo-exclamation info-tooltip")
                  span(class="hint") {{ text.tooltip_retirement }}
                span(class="padding-top") {{ text.label_retirement }}

            div(class="large-6 medium-6 small-12 columns")
              div(class="select-wrapper")
                select.dropdown(v-model="frmMarital.retire_age" :class="!frmMarital.retire_age ? 'invalid' : ''")
                  option(v-for="item in retireAges" :disabled="!item.value" :value="item.value" :key="item.value") {{ item.label }}

              div(v-if="checkValid && !$v.frmMarital.retire_age.valid" class="hint-wrapper")
                div(class="hint error open")
                  p {{ errorMessages.retire_age.valid }}

          div.row.form-spacing
            div.pr-0(class="large-6 medium-6 small-12 columns")
              label.pl-5(class="margin-top-label")
                i.info-tooltip--absolute(class="fo fo-exclamation info-tooltip")
                  span(class="hint") {{ text.tooltip_taxable }}
                span.d-inline-block(class="padding-top") zu versteuerndes Jahreseinkommen in €*

            div(class="large-6 medium-6 small-12 columns")
              n-number(
                v-model="frmMarital.taxable_income"
                :valid="!$v.frmMarital.taxable_income.$invalid"
                :checkValid="checkValid"
                :error="errorMessages.taxable_income.valid"
              )

          div.row.form-spacing
            div(class="large-6 medium-6 small-12 columns")
              label(class="margin-top-label")
              label.pl-5.padding-top(class="margin-top-label") Ich zahle bereits anderweitige Rentenbeiträge

            div(class="large-6 medium-6 small-12 columns")
              div(class="radio-button-wrapper form-spacing mt-2")
                input(v-model="showFrmCurrent" value="1" class="custom-radio" type="radio")
                label(@click="onShowFrmCurrent(1)")
                  span
                  div Ja

                input(v-model="showFrmCurrent" value="0" class="custom-radio" type="radio")
                label.ml-3(@click="onShowFrmCurrent(0)")
                  span
                  div Nein

          template(v-if="showFrmCurrent === 1")
            .highlight: .row
              .large-12.medium-12.small-12.columns
                label.mb-0 Beiträge in bestehende Vorsorgeversicherungen mindern den maximal steuerlich geförderten Beitrag

            div.mt-2(class="row form-spacing")
              div(class="large-12 medium-12 small-12 columns")
                div(class="float-left margin-top-label")
                  label(class="padding-top padding-left-25")
                    b Jahresbeitrag in €

            div.row.form-spacing(v-for="item in currentPension" :key="item.id")
              div(class="large-6 medium-6 small-12 columns")
                label(class="margin-top-label")
                  i(class="fo fo-exclamation info-tooltip")
                    span(class="hint") {{ item.tooltip }}
                  span(class="padding-top") {{ item.label }}

              div(class="large-6 medium-6 small-12 columns")
                n-number(v-model="frmCurrent[ item.id ]"
                  :valid="item.error ? !$v.frmCurrent[ item.id ].$invalid : true"
                  :checkValid="checkValid"
                  :error="item.error")

          div(class="row form-spacing")
            div(class="large-6 medium-6 small-12 columns")
              label.ml-5.mb-2 * Pflichtangaben

            div(class="large-6 medium-6 small-12 columns")
              a(href="#" class="button call-to-action block" @click="onCheckValidClick")
                span Weiter
                i(class="fo fo-arrow-right")

      div.row(v-else ref="form1")
        div.small-12.columns
          div(class="row form-spacing mb-0")
            div(class="large-4 medium-6 small-12 columns form-break-spacing")
              h4(class="feedback")
                span(:class="[ 'feedback-before', validForm1 ? 'validated' : '' ]")
                span Meine Daten

            div(class="large-4 large-offset-4 medium-6 small-12 columns")
              div(class="float-left margin-top-label")
                a(href="#" class="button button-link button-light" @click="onShowForm1")
                  i.mr-1(class="fa fa-pencil")
                  b Bearbeiten

      hr(class="topspace")

      div.row(v-if="!showForm2")
        div.small-12.columns
          div(class="row form-spacing")
            div(class="large-4 medium-12 small-12 columns form-break-spacing")
              h4(class="feedback")
                span(:class="[ 'feedback-before', validForm2 ? 'validated' : '' ]")
                span Mein BasisRenten-Wunschbeitrag

      div.row(v-else ref="form2")
        div.small-12.columns
          div(class="row form-spacing")
            div(class="large-4 medium-12 small-12 columns form-break-spacing")
              h4(class="feedback")
                span(:class="[ 'feedback-before', validForm2 ? 'validated' : '' ]")
                span Mein BasisRenten-Wunschbeitrag

            div(class="large-4 medium-6 small-12 columns")
              div(class="radio-button-wrapper")
                input(v-model="frmDesired.payment" value="true" class="custom-radio" type="radio")
                label(@click="frmDesired.payment = true")
                  span
                  div Einmalzahlung in €{{ frmDesired.payment === true ? '*' : '' }}

            div(class="large-4 medium-6 small-12 columns" v-if="frmDesired.payment")
              n-number(
                v-model="frmDesired.beitrag"
                :valid="!$v.frmDesired.beitrag.$invalid"
                :error="errorMessages.beitrag.between"
                :checkValid="checkValid"
              )

          div(class="row form-spacing")
            div(class="large-4 large-offset-4 medium-6 small-12 columns")
              div(class="radio-button-wrapper")
                input(v-model="frmDesired.payment" value="false" class="custom-radio" type="radio")
                label(@click="frmDesired.payment = false")
                  span
                  div Regelmäßiger Jahresbeitrag in €{{ frmDesired.payment === false ? '*' : '' }}

            div(class="large-4 medium-6 small-12 columns" v-if="!frmDesired.payment")
              n-number(
                v-model="frmDesired.beitrag"
                :valid="!$v.frmDesired.beitrag.$invalid"
                :error="errorMessages.beitrag.between"
                :checkValid="checkValid"
              )

          div(class="row form-spacing" v-if="!frmDesired.payment")
            div(class="large-4 large-offset-4 medium-6 small-12 columns")
              label(class="margin-top-label")
                i(class="fo fo-exclamation info-tooltip")
                  span(class="hint") Sie können ganz flexibel jedes Jahr Zuzahlungen in Ihre BasisRente (Rürup-Rente) leisten. Zur vereinfachten Darstellung des steuerlichen Vorteils haben wir die Zuzahlungsmöglichkeit hier auf den Vertragsbeginn beschränkt.
                span(class="padding-top") Zuzahlung zu Vertragsbeginn

            div(class="large-4 medium-6 small-12 columns")
              n-number(
                v-model="frmDesired.extra"
                :valid="!$v.frmDesired.extra.$invalid"
                :error="errorMessages.extra.between"
                :checkValid="checkValid"
              )

          div(class="row form-spacing")
            div(class="large-4 large-offset-4 medium-6 small-12 columns")
              label.ml-5.mb-2 * Pflichtangaben

            div(class="large-4 medium-6 small-12 columns")
              a(href="#" class="button call-to-action block" @click="onBerechnenClick")
                span Berechnen
                i(class="fo fo-arrow-right")

      hr(ref="result" class="topspace")

      template(v-if="resultPromotion")
        div.row.form-spacing
          div.large-4.medium-5.small-12.columns.text-center
            span.padding-top.h2 Mein Steuervorteil in {{ currentYear }}

        div.row.form-spacing
          div.large-4.medium-4.small-12.columns.form-break-spacing
            div.vkb-nak-chart
              chart(v-if="chartData" :data="chartData" :height="300")

          div.large-8.medium-8.small-12.columns
            div.row.tk-vkb-producttable.mt-6
              table.comparisonchart
                tbody
                  tr(v-for="result in resultDesired" :key="result.label")
                    td {{ result.label }}
                    td: span.h3 {{ result.value }} €

                tfoot: tr
                  td.presetting
                    span Meine gesamte Förderquote bis zum Rentenbeginn
                    span.presetting-bottom.h3.h2-line-height {{ formatMoney(resultPromotion.max_foerderung_quote, 2) }} %

                  td.summary
                    span Mein gesamter Steuervorteil bis zum Rentenbeginn
                    span.summary-bottom.h2 {{ formatMoney(resultPromotion.max_steurvorteil, 2) }} &euro;

        div.row.tk-vkb-producttable-action.tk-vkb-fullsizebg2.hide-all.show-large.show-medium
          div.small-12.columns: .row.table-columns
            div.small-12.medium-6.large-4.large-offset-4.columns
              a.button.button-link.ml-1(@click.prevent="onGetPdfClick")
                i.fo.fo-download
                span Steuervorteil speichern
                i.fa.fa-spinner.fa-spin(v-if="!!pdfJobId")

            div.small-12.medium-6.large-4.columns
              a.button.call-to-action.block(@click.prevent="onContactClick")
                span Zur Beratung
                i.fo.fo-arrow-right

              a.button.block(@click.prevent="(e) => onBerechnenClick(e, true)")
                i.fo.fo-calculator
                span Steuervorteil neu berechnen

        div.wrapper-spacing.tk-vkb-notopspace.hide-all.show-small
          div.row
            div.small-12.columns.topspace
              a.button.button-link.block(@click.prevent="onGetPdfClick")
                i.fo.fo-download
                span Steuervorteil speichern
                i.fa.fa-spinner.fa-spin(v-if="!!pdfJobId")

            div.small-12.columns.topspace
              a.button.call-to-action.block(@click.prevent="onContactClick")
                span Zur beratung
                i.fo.fo-arrow-right

              a.button.block(@click.prevent="(e) => onBerechnenClick(e, true)")
                i.fo.fo-calculator
                span Steuervorteil neu berechnen
</template>

<script>
import logic from './logic.js';

export default {
  name: 'ruerup_rente_vkb',
  mixins: [ logic ],
  created() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll: function() {
      this.hideTableNavBar('table-result', 'table-nav');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/ruerup_rente/fsoel.vue